import React from 'react';
import { Box, Chip, Typography, Tooltip, IconButton, CircularProgress } from '@mui/material';
import { CheckCircle, Warning, Error, Refresh } from '@mui/icons-material';
import { SystemStatus } from '../types/dashboard';
import { formatTime } from '../utils/formatters';

interface SystemStatusIndicatorProps {
  status: SystemStatus;
  loading?: boolean;
  onRefresh?: () => void;
}

const SystemStatusIndicator: React.FC<SystemStatusIndicatorProps> = ({ status, loading = false, onRefresh }) => {
  const getStatusIcon = () => {
    switch (status.status) {
      case 'healthy':
        return <CheckCircle />;
      case 'warning':
        return <Warning />;
      case 'error':
        return <Error />;
      default:
        return <Warning />;
    }
  };

  const getStatusColor = () => {
    switch (status.status) {
      case 'healthy':
        return 'success';
      case 'warning':
        return 'warning';
      case 'error':
        return 'error';
      default:
        return 'default';
    }
  };

  return (
    <Tooltip title={status.message || `Uptime: ${status.uptime}%`}>
      <Box display="flex" alignItems="center" gap={1}>
        <Chip
          icon={loading ? <CircularProgress size={16} /> : getStatusIcon()}
          label={loading ? 'LOADING' : status.status.toUpperCase()}
          color={getStatusColor() as any}
          variant="filled"
          size="small"
        />
        <Typography variant="caption" color="text.secondary">
          {formatTime(status.lastUpdate)}
        </Typography>
        {onRefresh && (
          <IconButton 
            size="small" 
            onClick={onRefresh}
            disabled={loading}
            title="Refresh status"
          >
            <Refresh fontSize="small" />
          </IconButton>
        )}
      </Box>
    </Tooltip>
  );
};

export default SystemStatusIndicator;
